import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState(""); // honeypot
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", { email, company });
      toast.success("Danke! Du erhältst künftig Ausstellungs-Ankündigungen.");
      setEmail("");
    } catch (err) {
      toast.error("Anmeldung fehlgeschlagen. Bitte später erneut versuchen.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="border-b border-[#632A8E]/50">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-10 flex flex-col md:flex-row md:items-center gap-6 md:justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[#F4C542] mb-2">Newsletter</div>
          <p className="font-serif text-2xl text-[#FFF9F2]">Ausstellungen &amp; Neuigkeiten</p>
          <p className="text-sm text-[#D8B9EA] mt-1">Erhalte Ankündigungen zu neuen Werken und Ausstellungen.</p>
        </div>
        <form onSubmit={submit} className="flex w-full md:w-auto gap-3" data-testid="newsletter-form">
          <input type="text" value={company} onChange={(e) => setCompany(e.target.value)} className="hidden" tabIndex={-1} autoComplete="off" aria-hidden="true" />
          <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="deine@email.ch" data-testid="newsletter-email" className="bg-white text-[#32104F] rounded-md h-12 md:w-72" />
          <Button type="submit" disabled={loading} data-testid="newsletter-submit" className="bg-[#F4C542] text-[#32104F] hover:bg-[#D85CA4] rounded-md h-12 px-6 whitespace-nowrap">
            {loading ? "…" : "Anmelden"}
          </Button>
        </form>
      </div>
    </div>
  );
}
